import { render, staticRenderFns } from "./atlas.vue?vue&type=template&id=f46809d6&scoped=true"
import script from "./atlas.vue?vue&type=script&lang=js"
export * from "./atlas.vue?vue&type=script&lang=js"
import style0 from "./atlas.vue?vue&type=style&index=0&id=f46809d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46809d6",
  null
  
)

export default component.exports